import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Ticker } from "@/components/landing/Ticker";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Features } from "@/components/landing/Features";
import { Partners } from "@/components/landing/Partners";
import { Footer } from "@/components/landing/Footer";

const LandingPage = () => (
    <div className="min-h-screen bg-[#111111] text-white" data-testid="landing-page">
        <div className="grain-overlay" aria-hidden="true" />
        <Nav />
        <main>
            <Hero />
            <Ticker />
            <HowItWorks />
            <Features />
            <Partners />
        </main>
        <Footer />
    </div>
);

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LandingPage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
